const toNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const clampPercent = (value) => {
  return Math.min(100, Math.max(0, toNumber(value)));
};

export const isOrderBundleItem = (item) => {
  return Boolean(String(item?.bundle_group_id || "").trim());
};

export const getOrderItemOriginalPrice = (item) => {
  return toNumber(
    item?.original_price ??
      item?.price ??
      item?.variant?.price ??
      item?.unit_price,
  );
};

export const getOrderItemQuantityValue = (item) => {
  const quantity = toNumber(item?.quantity, 1);
  return quantity > 0 ? quantity : 1;
};

export const getOrderBundlePricing = (bundle) => {
  const items = Array.isArray(bundle?.items) ? bundle.items : [];
  const originalSubtotal = items.reduce((sum, item) => {
    const originalPrice = getOrderItemOriginalPrice(item);
    const quantity = getOrderItemQuantityValue(item);
    return sum + originalPrice * quantity;
  }, 0);

  const discountPercent = clampPercent(
    items.find(
      (item) =>
        item?.discount_percent !== null && item?.discount_percent !== undefined,
    )?.discount_percent ?? 0,
  );

  const discountAmount = originalSubtotal * (discountPercent / 100);
  const total = Math.max(originalSubtotal - discountAmount, 0);
  const quantity = items.length > 0 ? getOrderItemQuantityValue(items[0]) : 0;

  return {
    originalSubtotal,
    discountPercent,
    discountAmount,
    total,
    quantity,
  };
};

export const groupOrderItems = (items = []) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const bundleMap = new Map();
  const entries = [];

  items.forEach((item, index) => {
    const bundleGroupId = String(item?.bundle_group_id || "").trim();

    if (!bundleGroupId) {
      entries.push({
        type: "item",
        key: `item-${item?.id ?? item?.product_name ?? index}-${index}`,
        item,
      });

      return;
    }

    let bundle = bundleMap.get(bundleGroupId);
    if (!bundle) {
      bundle = {
        type: "bundle",
        key: `bundle-${bundleGroupId}`,
        id: bundleGroupId,
        name: item?.bundle_name || "Bundle",
        items: [],
      };

      bundleMap.set(bundleGroupId, bundle);
      entries.push(bundle);
    }
    bundle.items.push(item);
  });
  return entries;
};
